// Procedures 5013
const ProcedureService = '/procedures';

// Controllers
const ProcedureController = `${ProcedureService}/procedures`;
const TrainingRequestController = `${ProcedureService}/training-requests`;
const CooperativeTrainingController = `${ProcedureService}/cooperative-trainings`;
const PractitionersTrainingController = `${ProcedureService}/practitioners-trainings`;
const TrainingNeedsController = `${ProcedureService}/training-needs`;

const SharedRoutes = {
    MyRequests: 'my-requests',
    RequestId: (requestId) => `${requestId}`,
    Action: (requestId, actionType) => `${requestId}/actions/${actionType}`,
    ApprovalCycle: 'request-approval',
    DelegationCycle: 'request-delegation',
};

export const ProceduresService = {
    Procedure: {
        Procedures: ProcedureController,
        ProcedureId: (procedureId) => `${ProcedureController}/${procedureId}`,
        MyProcedures: `${ProcedureController}/my-procedures`,
        SharedRoutes: SharedRoutes,
    },
    TrainingRequest: {
        TrainingRequests: TrainingRequestController,
        TrainingRequestId: (trainingRequestId) => `${TrainingRequestController}/${trainingRequestId}`,
        MyRequests: `${TrainingRequestController}/my-requests`,
        TrainingRequestFile: (trainingRequestId, type) => `${TrainingRequestController}/${trainingRequestId}/files/${type}`,
        ApprovalCycle: `${TrainingRequestController}/request-approval`,
        DelegationCycle: `${TrainingRequestController}/request-delegation`,
        DecisionDetails: (trainingRequestId) => `${TrainingRequestController}/${trainingRequestId}/decision`,
        DecisionFile: (decisionNo) => `${TrainingRequestController}/decisions/${decisionNo}/download`
    },
    CooperativeTraining: {
        CooperativeTrainings: CooperativeTrainingController,
        CooperativeTrainingId: (cooperativeTrainingId) => `${CooperativeTrainingController}/${cooperativeTrainingId}`,
        MyRequests: `${CooperativeTrainingController}/my-requests`,
        ApprovalCycle: `${CooperativeTrainingController}/request-approval`,
        DelegationCycle: `${CooperativeTrainingController}/request-delegation`,
        UniversityLetter: (cooperativeTrainingId) => `${CooperativeTrainingController}/${cooperativeTrainingId}/university-letter`,
        Certificate: (cooperativeTrainingId, traineeId) => `${CooperativeTrainingController}/${cooperativeTrainingId}/certificate/${traineeId}`,
    },
    PractitionersTraining:
    {
        Controller: PractitionersTrainingController,
        PractitionersTrainingId: (requestId) => `${PractitionersTrainingController}/${requestId}`,
        MyRequests: `${PractitionersTrainingController}/my-requests`,
        ApprovalCycle: `${PractitionersTrainingController}/request-approval`,
    },
    TrainingNeeds:
    {
        Requests: TrainingNeedsController,
        RequestId: (requestId) => `${TrainingNeedsController}/${requestId}`,
        UpdateStatus: (trainingRequestId, status) => `${TrainingNeedsController}/${trainingRequestId}/${status}`,
        MyRequests: `${TrainingNeedsController}/${SharedRoutes.MyRequests}`,
        Action: `${TrainingNeedsController}/${SharedRoutes.Action}`,
        DelegationOrganizations: `${TrainingNeedsController}/delegation/organizations`,
        DelegationUsers: `${TrainingNeedsController}/delegation/users`,
    },
};
